module.exports = "/assets/data/feddbc5954d20a0fb6d886a68c8d5a43-NG34.data.json";